import { ThemeProvider, createTheme } from '@mui/material';
import { useAtom } from 'jotai';
import { Navigate, Route, Routes } from 'react-router-dom';
import { accessToken } from './atoms/atom';
import End from './paginas/end/End';
import Home from './paginas/home/Home';
import Login from './paginas/login/Login';
import Orientacoes from './paginas/orientations/Orientacoes';
import Orientacoes2 from './paginas/orientations2/Orientacoes2';
import Orientacoes3 from './paginas/orientations3/Orientacoes3';
import Question from './paginas/question/Question';
import Inicio from './paginas/start/Inicio';

function App() {
	const [, setAccessToken] = useAtom(accessToken);
	const darkTheme = createTheme({
		palette: {
			mode: 'light',
		},
	});

	setAccessToken(localStorage.getItem('access-token'));

	return (
		<ThemeProvider theme={darkTheme}>
			<Routes>
				<Route path="/:id/login" element={ <Login/>} />
				<Route path="/:id/inicio" element={ <Inicio/>} />
				<Route path="/" element={ <Home/>} />
				<Route path="/:id/orientacoes" element={ <Orientacoes/>} />
				<Route path="/:id/orientacoes2" element={ <Orientacoes2/>} />
				<Route path="/:id/orientacoes3" element={ <Orientacoes3/>} />
				<Route path="/:id/fim" element={ <End/>} />
				<Route path="/:id/pergunta" element={ <Question/>} />
				<Route path="*" element={<Navigate to="/" replace />} />
			</Routes>
		</ThemeProvider>
	);
}

export default App;
